import { render } from "./come-soon.vue?vue&type=template&id=7f9023b2"
import script from "./come-soon.vue?vue&type=script&lang=js"
export * from "./come-soon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__